import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}
/* eslint-disable class-methods-use-this */


var Tracking = /*#__PURE__*/function () {
  function Tracking() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Tracking);

    this.options = _objectSpread({
      dataLayer: window.dataLayer || null
    }, opts);
  }

  _createClass(Tracking, [{
    key: "push",
    value: function push() {
      var dataLayer = this.options.dataLayer;

      if (dataLayer === null) {
        return;
      }

      dataLayer.push.apply(dataLayer, arguments);
    }
  }, {
    key: "trackEvent",
    value: function trackEvent(category, action) {
      var label = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var value = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      this.push({
        event: 'eventInteraction',
        eventCategory: category,
        eventAction: action,
        eventLabel: label,
        eventValue: value
      });
    }
  }, {
    key: "trackSocial",
    value: function trackSocial(network, action) {
      var target = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      this.push({
        event: 'socialInteraction',
        socialNetwork: network,
        socialAction: action,
        socialTarget: target || "".concat(window.location.protocol, "//").concat(window.location.host)
      });
    }
  }]);

  return Tracking;
}();

export default Tracking;